// extracted by mini-css-extract-plugin
module.exports = {"tile":"SpaceCategoryTile_tile__J2e9l"};